import React from 'react';
import { IStore } from 'Store/.';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { withRouter } from 'react-router-dom';
import { Dispatch, bindActionCreators } from 'redux';
import { fetchOrderWithCampaign } from 'Store/Order/thunks';
import WrapperBox from 'Components/Shared/WrapperBox/WrapperBox';
import VoucherPicker from 'Components/PickVoucher/PickVoucher';

import { 
  getIsDiscountFailed, 
  getSelectedVouchers,
  getIsFetchingDiscount,
  getOrderSeats,
} from 'Store/Order/selectors';

interface IPropsInternal {
  isFetching: boolean;
  isDiscountFailed: boolean;
  vouchers: Julius.Website.VoucherViewModel[];
  seats: Julius.Website.OrderSeatViewModel[],
  fetchOrderWithCampaign: (code: string) => void;
}

type Props = IPropsInternal;

interface IState {
  currentInput: string;
  isShowingWarning: boolean;
}

class PickVoucherContainer extends React.Component<Props, IState> {
  constructor(props: Props) {
    super(props);

    this.state = {
      currentInput: '',
      isShowingWarning: false,
    }
  }

  componentWillReceiveProps(nextProps: Props) {
    const { isDiscountFailed, isFetching } = nextProps;
    const { isShowingWarning } = this.state;

    if (isFetching) {
      return;
    }
    if (isDiscountFailed && !isShowingWarning) {
      this.setState({ isShowingWarning: true });
    }
    if (!isDiscountFailed) {
      this.setState({ currentInput: '', isShowingWarning: false });
    }
  }

  onChange = (e: React.FormEvent<HTMLInputElement>) => {
    this.setState({ 
      currentInput: e.currentTarget.value, 
      isShowingWarning: false, 
    });
  }

  onSubmit = () => {
    const { currentInput } = this.state;
    if (currentInput && currentInput.length) {
      this.props.fetchOrderWithCampaign(currentInput);
    }
  }

  render() {
    return (
      <WrapperBox>
        <VoucherPicker 
          isFetching={ this.props.isFetching }
          isShowingWarning={ this.state.isShowingWarning }
          discountWeekdayValid={ this.props.seats.every(seat => seat.discountWeekdayValid) }
          currentInput={ this.state.currentInput }
          vouchers={ this.props.vouchers }
          onChange={ this.onChange }
          onSubmit={ this.onSubmit }
        />
      </WrapperBox>
    );
  }
}

const mapStateToProps = (state: IStore) => {
  return {
    isFetching: getIsFetchingDiscount(state),
    isDiscountFailed: getIsDiscountFailed(state),
    vouchers: getSelectedVouchers(state),
    seats: getOrderSeats(state),
  };
};

const mapDispatchToProps = (dispatch: Dispatch) => {
  return bindActionCreators({
    fetchOrderWithCampaign,
  }, dispatch);
};

export default compose<{}, {}>(
  withRouter,
  injectIntl,
  connect(mapStateToProps, mapDispatchToProps),
)(PickVoucherContainer);


// WEBPACK FOOTER //
// ./src/components/PickVoucher/PickVoucherContainer.tsx